export enum PopupActionTypes {
  SET_OPENED_POPUP = 'SET_OPENED_POPUP',
}
